import React from 'react'

export const FormSkeleton: React.FC = () => {
  return (
    <div className="w-full rounded-md lg:w-[666px] bg-bg-base-transparent-95 lg:min-h-[460px] h-full mt-6 p-8">
      <div className="flex flex-col gap-6">
        {/* Title Section */}
        <div className="flex flex-col gap-4">
          <div className="animate-pulse h-8 bg-gray-200 rounded w-48"></div>
          <div className="animate-pulse h-4 bg-gray-200 rounded w-full max-w-96"></div>
        </div>

        <div className="flex flex-col gap-4">
          <div>
            <div className="animate-pulse h-4 bg-gray-200 rounded w-16 mb-2"></div>
            <div className="animate-pulse h-10 bg-bg-base rounded w-full border border-border-input"></div>
          </div>
          <div>
            <div className="animate-pulse h-4 bg-gray-200 rounded w-16 mb-2"></div>
            <div className="animate-pulse h-[120px] bg-bg-base rounded w-full border border-border-input"></div>
          </div>
          <div className="flex justify-end mt-2">
            <div className="animate-pulse h-[38px] w-[72px] bg-blue-20 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  )
}
